import styled from "@emotion/styled";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import { Stack } from "@mui/material";
import { SocialIcon } from "react-social-icons";

const Container = styled.div`
  margin-top: 50pt;
  margin-bottom: 30pt;
  text-align: center;
`;

const EtsyIcon = styled.a`
  background-color: #333;
  color: #fff;
  border-radius: 25px;
  width: 50px;
  text-align: center;
  padding-top: 13px;
`

const FooterStack = styled(Stack)`
  margin-top: 40px;
`;

const Footer = (): JSX.Element => {
  return (
    <Container>
      <FooterStack spacing={2} direction={"row"} justifyContent={"center"}>
        <EtsyIcon
          href="https://www.etsy.com/uk/shop/BhagyaPereraArt"
          title="Etsy"
          target="_blank"
        ><ShoppingCartOutlinedIcon /></EtsyIcon>
        <SocialIcon
          url="https://www.instagram.com/bhagya_perera_art"
          bgColor="#333"
          fgColor="#fff"
          target="_blank"
          title="Instagram"
        />
        <SocialIcon
          url="https://www.facebook.com/bhagyaperera.art.7"
          bgColor="#333"
          fgColor="#fff"
          target="_blank"
          title="Facebook"
        />
        <SocialIcon
          url="mailto:bhagyapereraart@gmail.com"
          bgColor="#333"
          fgColor="#fff"
          target="_blank"
          title="Email"
        />
      </FooterStack>

      <FooterStack>&copy; Bhagya Perera, 2025</FooterStack>
    </Container>
  )
}

export default Footer;